import type { ReactNode } from "react";

export type InputCardProps = {
  index: 1 | 2 | 3 | 4;
  title: string;
  value: ReactNode;
  affordance?: ReactNode;   // e.g. "from event" tag, "override ▾", "edit ✎"
  detail?: ReactNode;       // key engineering values + provenance (audit rows)
  testid?: string;
};

export function InputCard({ index, title, value, affordance, detail, testid }: InputCardProps) {
  return (
    <div className="study-input-card" data-testid={testid}>
      <div className="study-input-card-head">
        <span className="study-input-card-index">{index}</span>
        <span className="study-input-card-title">{title}</span>
        {affordance && <span className="study-input-card-affordance">{affordance}</span>}
      </div>
      <div className="study-input-card-value">{value}</div>
      {detail && <div className="study-input-card-detail">{detail}</div>}
    </div>
  );
}
